import * as CONSTANTS from './constants'

export const HEADER_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded",
};

export const HEADER_BASIC_ENCODED = {
  "Content-Type": "application/x-www-form-urlencoded",
  "Authorization": `Basic`,
}
export const HEADER_ALLOW_ORIGIN = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  "Access-Control-Allow-Origin": "*",
  "Authorization": "Basic Z2xlZS1vLW1ldGVyOnNlY3JldA==",
};

export const HEADER_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
}

export const setToken = (token = '') => {
  localStorage.setItem(CONSTANTS.LOCAL_STORAGE_AUTH_TOKEN, token)
}

export const setPassword = (password = '') => {
  localStorage.setItem(CONSTANTS.PASSWORD, password)
}

export const clearToken = () => {
  // localStorage.removeItem(CONSTANTS.LOCAL_STORAGE_AUTH_TOKEN)
  localStorage.clear()
}

export const getToken = () =>
  localStorage.getItem(CONSTANTS.LOCAL_STORAGE_AUTH_TOKEN) || ''

export const getPassword = () =>
  localStorage.getItem("password") || ''

